import dayjs from 'dayjs';

import { CalendarData, CalendarEntry } from './types';

export const isDateToday = (datetime: number) => dayjs().isSame(dayjs(datetime), 'day');

const getDateInMs = (datetime: number) => dayjs(datetime).startOf('day').valueOf();

export const splitEntriesByDay = (entries: CalendarEntry<any>[] | undefined): CalendarData => {
  const output: CalendarData = {};

  if (entries) {
    entries.forEach((entry) => {
      const entryDate = getDateInMs(entry.startDatetime);

      if (!output[entryDate]) output[entryDate] = [entry];
      else {
        output[entryDate].push(entry);
      }
    });
  }

  // Sort by datetimeId for each day
  Object.values(output).forEach((day) => {
    day.sort((a: CalendarEntry<any>, b: CalendarEntry<any>) =>
      a.startDatetime - b.startDatetime);
  });

  return output;
};
